import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialWaitingHourglassLoading: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M19.81 26.67v1.52h3.04v1.53H9.14v-1.53h3.05v-1.52H9.14v-3.05H7.62v6.1H4.57v1.52h22.86v-1.52h-3.05v-6.1h-1.53v3.05z\"/><path fill=\"currentColor\" d=\"M21.33 20.57h1.52v3.05h-1.52Zm0-12.19h1.52v3.05h-1.52Zm-1.52 10.67h1.52v1.52h-1.52Zm-1.53-1.52h1.53v1.52h-1.53Zm-1.52 7.61h3.05v1.53h-3.05Z\"/><path fill=\"currentColor\" d=\"M19.81 14.48v-1.53h1.52v-1.52H10.66v1.52h1.53v1.53h1.52v3.05h1.53v7.61h1.52v-7.61h1.52v-3.05zm-7.62 10.66h3.05v1.53h-3.05Z\"/><path fill=\"currentColor\" d=\"M12.19 17.53h1.52v1.52h-1.52Zm-1.53 1.52h1.53v1.52h-1.53Zm-1.52 1.52h1.52v3.05H9.14Zm0-12.19h1.52v3.05H9.14Zm0-6.09h13.71v6.09h1.53V2.29h3.05V.76H4.57v1.53h3.05v6.09h1.52z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialWaitingHourglassLoading
